<p-toast></p-toast>
<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="rd-info" *ngIf="!podeSql">
  Só quem tem a permissão de editar SQL (.S.) abre as fontes. Peça a um coordenador para marcar a permissão no seu usuário.
</div>

<div class="fs" #raiz *ngIf="podeSql" [style.height]="alturaBancada">
  <header class="fs-topo">
    <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-rounded p-button-secondary" aria-label="Voltar para a lista"
      (click)="voltar()"></button>
    <div class="fs-identidade">
      <h1>{{ titulo }}</h1>
      <div class="fs-identidade-meta">
        <code *ngIf="fonte.chave">{{ fonte.chave }}</code>
        <span class="situacao situacao-rascunho">{{ rotuloSituacao }}</span>
        <a href="javascript:void(0)" class="fs-uso" *ngIf="modelos.length" (click)="abaInspetor = 0">
          usada por {{ modelos.length }} {{ modelos.length === 1 ? 'modelo' : 'modelos' }}
        </a>
      </div>
    </div>
    <habil-seletor-base></habil-seletor-base>
    <input #arquivoJrxml type="file" accept=".jrxml" hidden (change)="lerJrxml($event)" />
    <button pButton type="button" class="p-button-text p-button-secondary" icon="pi pi-upload" label="Ler JRXML"
      title="Mostra as variáveis, os avisos e o modelo sugerido de um JRXML, sem trocar o SQL" (click)="arquivoJrxml.click()"></button>
    <button pButton type="button" class="p-button-text p-button-secondary" icon="pi pi-history" label="Histórico" [disabled]="!versaoAtual"
      (click)="abrirHistorico()"></button>
    <button pButton type="button" class="p-button-outlined" label="Salvar rascunho" (click)="salvarRascunho()"></button>
    <button pButton type="button" icon="pi pi-check" [label]="'Salvar versão ' + proximaVersao" (click)="abrirSalvarVersao()"></button>
  </header>

  <div #bancada class="fs-bancada" [class.fs-arrastando]="arrastando" [style.grid-template-columns]="'minmax(0, 1fr) 8px ' + larguraInspetor + 'px'">
    <div class="fs-esquerda">
      <p-splitter styleClass="fs-vertical" layout="vertical" [panelSizes]="[58, 42]" [minSizes]="[25, 20]" stateKey="rd-fonte-linhas" stateStorage="local">
        <ng-template pTemplate>
          <section class="fs-editor" aria-label="SQL da fonte">
            <div class="fs-faixa">
              <span class="fs-faixa-titulo">SQL</span>
              <span class="fs-alerta" *ngIf="naoDeclarados.length">
                <i class="pi pi-exclamation-triangle"></i>
                sem declaração:
                <code *ngFor="let n of naoDeclarados">:{{ n }}</code>
                <button type="button" class="fs-link" (click)="declararFaltantes(); abaInspetor = 1">declarar</button>
              </span>
              <span class="fs-dica-atalho"><kbd>Ctrl</kbd> + <kbd>Enter</kbd> roda a prévia</span>
            </div>
            <div class="fs-editor-area">
              <habil-editor-codigo [(valor)]="fonte.sql" (executar)="rodarPrevia()" linguagem="sql" altura="100%" nomeArquivo="fonte.sql" [dicionario]="dicionario">
              </habil-editor-codigo>
            </div>
          </section>
        </ng-template>

        <ng-template pTemplate>
          <section class="fs-console" aria-label="Resultados">
            <div class="fs-faixa fs-console-acoes">
              <span class="fs-faixa-titulo">RESULTADO</span>
              <span class="rd-espaco"></span>
              <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-check-square" label="Validar" (click)="validar()"></button>
              <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-table" label="Detectar colunas" (click)="detectarColunas()"></button>
              <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-sitemap" label="Plano de execução" (click)="rodarPlano()"></button>
              <button pButton type="button" class="p-button-sm" icon="pi pi-play" label="Rodar prévia" [loading]="ocupado === 'Rodando prévia'"
                (click)="rodarPrevia()"></button>
            </div>
            <div class="fs-caixa">
            <p-tabView [(activeIndex)]="abaConsole" styleClass="fs-abas">
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span>Prévia</span>
                  <span class="fs-contador" *ngIf="previa">{{ totalPrevia | number: '1.0-0':'pt-BR' }}</span>
                </ng-template>
                <div class="fs-vazio-grande" *ngIf="!previa">
                  <i class="pi pi-play"></i>
                  <p>Escolha a base no topo, confira os valores de teste em <strong>Parâmetros</strong> e rode a prévia.</p>
                </div>
                <ng-container *ngIf="previa">
                  <div class="fs-filtros">
                    <span class="rd-chip" *ngFor="let f of previa.filtros"><strong>{{ f.rotulo }}:</strong> {{ f.texto }}</span>
                  </div>
                  <p-table [value]="previa.linhas" [scrollable]="true" scrollHeight="flex" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped fs-grade-previa"
                    [lazy]="true" [lazyLoadOnInit]="false" (onLazyLoad)="trocarPaginaPrevia($event)" [paginator]="totalPrevia > porPaginaPrevia"
                    [rows]="porPaginaPrevia" [first]="primeiraPrevia" [totalRecords]="totalPrevia" [rowsPerPageOptions]="[50, 100, 200]"
                    [showCurrentPageReport]="true" currentPageReportTemplate="{first}–{last} de {totalRecords}" [loading]="ocupado === 'Rodando prévia'">
                    <ng-template pTemplate="header">
                      <tr>
                        <th *ngFor="let c of colunasPrevia"><code>{{ c }}</code></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-linha>
                      <tr>
                        <td *ngFor="let c of colunasPrevia">{{ linha[c] }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="colunasPrevia.length || 1">Nenhuma linha nesta base com esses valores. Confira os valores de teste em Parâmetros.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </ng-container>
              </p-tabPanel>

              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span>Checagens</span>
                  <span class="fs-contador" [class.fs-contador-erro]="validacao?.erros?.length" *ngIf="qtdeChecagens">{{ qtdeChecagens }}</span>
                </ng-template>
                <div class="fs-checagens">
                  <div class="fs-vazio-grande" *ngIf="!validacao && !plano">
                    <i class="pi pi-check-square"></i>
                    <p>"Validar" confere o SQL e os parâmetros. "Plano de execução" roda o EXPLAIN na base escolhida.</p>
                  </div>
                  <div class="fs-item fs-item-erro" *ngFor="let e of validacao?.erros"><i class="pi pi-times-circle"></i>{{ e }}</div>
                  <div class="fs-item fs-item-aviso" *ngFor="let a of validacao?.avisos"><i class="pi pi-exclamation-circle"></i>{{ a }}</div>
                  <div class="fs-item fs-item-ok" *ngIf="validacao && !validacao.erros?.length">
                    <i class="pi pi-check-circle"></i>Um comando só, sem escrita nem função proibida, parâmetros conferidos.
                  </div>
                  <ng-container *ngIf="plano">
                    <div class="fs-item fs-item-info">
                      <i class="pi pi-sitemap"></i>
                      Plano em {{ plano.base }}: custo <strong>{{ plano.custo | number: '1.0-0' }}</strong>, {{ plano.linhasEstimadas | number: '1.0-0' }} linhas estimadas.
                    </div>
                    <div class="fs-item fs-item-aviso" *ngFor="let a of plano.avisos"><i class="pi pi-exclamation-circle"></i>{{ a }}</div>
                    <div class="fs-item fs-item-ok" *ngIf="!plano.avisos?.length"><i class="pi pi-check-circle"></i>Sem varredura completa em tabela grande.</div>
                  </ng-container>
                </div>
              </p-tabPanel>

              <p-tabPanel *ngIf="avisosImportacao.length || sugestaoModelo">
                <ng-template pTemplate="header">
                  <span>Importação</span>
                  <span class="fs-contador fs-contador-aviso" *ngIf="avisosImportacao.length">{{ avisosImportacao.length }}</span>
                </ng-template>
                <div class="fs-checagens">
                  <div class="fs-item fs-item-info"><i class="pi pi-upload"></i>Lido de <strong>{{ origemImportacao }}</strong>. Revise antes de salvar.</div>
                  <div class="fs-sugestao" *ngIf="sugestaoModelo">
                    <div class="fs-sugestao-texto">
                      <strong>Modelo sugerido pelo JRXML</strong>
                      <span *ngFor="let l of resumoSugestao">{{ l }}</span>
                      <small *ngIf="!versaoAtual">Salve uma versão da fonte para criar o modelo.</small>
                    </div>
                    <button pButton type="button" class="p-button-sm" icon="pi pi-plus" label="Criar modelo"
                      [disabled]="!versaoAtual || !!ocupado" (click)="criarModeloSugerido()"></button>
                  </div>
                  <div class="fs-item fs-item-aviso" *ngFor="let a of avisosImportacao"><i class="pi pi-exclamation-circle"></i>{{ a }}</div>
                </div>
              </p-tabPanel>
            </p-tabView>
            </div>
          </section>
        </ng-template>
      </p-splitter>
    </div>

    <div class="fs-divisor" role="separator" aria-orientation="vertical" aria-label="Largura do painel da direita" tabindex="0"
      [attr.aria-valuenow]="larguraInspetor" (pointerdown)="iniciarArraste($event)" (pointermove)="arrastar($event)"
      (pointerup)="soltarArraste($event)" (pointercancel)="soltarArraste($event)" (dblclick)="definirLarguraInspetor(LARGURA_INSPETOR_PADRAO)"
      (keydown.arrowleft)="definirLarguraInspetor(larguraInspetor + 24); $event.preventDefault()"
      (keydown.arrowright)="definirLarguraInspetor(larguraInspetor - 24); $event.preventDefault()">
      <span></span>
    </div>

    <aside class="fs-inspetor" aria-label="Definição da fonte">
      <div class="fs-caixa">
      <p-tabView [(activeIndex)]="abaInspetor" styleClass="fs-abas">
        <p-tabPanel header="Fonte">
          <div class="fs-form">
            <label for="f-titulo">Título</label>
            <input id="f-titulo" type="text" pInputText [(ngModel)]="fonte.titulo" />
            <label for="f-chave">Chave</label>
            <input id="f-chave" type="text" pInputText class="fs-mono" [(ngModel)]="fonte.chave" [readonly]="!!versaoAtual" placeholder="vendas-notas" />
            <small class="fs-ajuda" *ngIf="versaoAtual">A chave não muda depois da primeira versão: os modelos citam a fonte por ela.</small>
            <label for="f-descricao">Descrição</label>
            <textarea id="f-descricao" pInputTextarea rows="2" [autoResize]="true" [(ngModel)]="fonte.descricao"
              placeholder="O que cada linha representa. Ex.: uma linha por nota de venda não cancelada."></textarea>
            <label for="f-rotina">Rotina exigida</label>
            <p-dropdown inputId="f-rotina" [options]="rotinas" [(ngModel)]="fonte.rotinaExigida" [filter]="true" [showClear]="true"
              placeholder="Nenhuma" appendTo="body" styleClass="fs-cheio"></p-dropdown>
            <small class="fs-ajuda">Só roda o relatório quem tem esta rotina na licença e no grupo de acesso.</small>
            <label for="f-software">Software</label>
            <p-dropdown inputId="f-software" [options]="softwares" [(ngModel)]="fonte.software" appendTo="body" styleClass="fs-cheio"></p-dropdown>
            <div class="fs-check">
              <p-checkbox inputId="f-sem-empresa" [(ngModel)]="fonte.semEmpresa" [binary]="true"></p-checkbox>
              <label for="f-sem-empresa">Não filtra por empresa (cadastro compartilhado)</label>
            </div>
          </div>
          <div class="fs-bloco" *ngIf="modelos.length">
            <div class="fs-bloco-titulo">Modelos que usam esta fonte</div>
            <a href="javascript:void(0)" class="fs-modelo" *ngFor="let m of modelos" (click)="abrirModelo(m)">
              <span>{{ m.titulo }}</span>
              <small *ngIf="m.fonteVersao">publicado sobre a v{{ m.fonteVersao }}</small>
            </a>
            <small class="fs-ajuda">Uma versão nova não muda nada nos clientes até o modelo ser republicado.</small>
          </div>
          <div class="fs-perigo" *ngIf="(temRascunho && versaoAtual) || (id && podeExcluir && !modelos.length)">
            <button pButton type="button" class="p-button-text p-button-secondary p-button-sm" label="Descartar rascunho" *ngIf="temRascunho && versaoAtual"
              (click)="descartarRascunho()"></button>
            <button pButton type="button" class="p-button-text p-button-danger p-button-sm" label="Excluir fonte" *ngIf="id && podeExcluir && !modelos.length" (click)="excluir()"></button>
          </div>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>Parâmetros</span>
            <span class="fs-contador" [class.fs-contador-erro]="naoDeclarados.length">{{ fonte.parametros.length }}</span>
          </ng-template>
          <p class="fs-ajuda fs-ajuda-topo">
            Um período <code>x</code> vira <code>:x_inicio</code> e <code>:x_fim</code>, com o fim já +1 dia: compare com <code>&lt;</code>.
            O valor de teste só vale para a prévia aqui.
          </p>
          <p-accordion [multiple]="true" styleClass="fs-parametros">
            <p-accordionTab *ngFor="let p of fonte.parametros; let i = index">
              <ng-template pTemplate="header">
                <div class="fs-param-cabecalho">
                  <code class="fs-param-nome">:{{ p.nome || '?' }}</code>
                  <span class="fs-tipo">{{ p.tipo }}</span>
                  <span class="fs-param-valor">{{ resumoValor(p) }}</span>
                </div>
              </ng-template>
              <div class="fs-form fs-form-param">
                <div class="fs-duas">
                  <div>
                    <label [for]="'p-nome-' + i">Nome</label>
                    <input [id]="'p-nome-' + i" type="text" pInputText class="fs-mono" [(ngModel)]="p.nome" />
                  </div>
                  <div>
                    <label [for]="'p-tipo-' + i">Tipo</label>
                    <p-dropdown [inputId]="'p-tipo-' + i" [options]="tiposParametro" [(ngModel)]="p.tipo" appendTo="body" styleClass="fs-cheio"></p-dropdown>
                  </div>
                </div>
                <ng-container *ngIf="p.tipo !== 'empresas'">
                  <label [for]="'p-rotulo-' + i">Rótulo que o usuário vê</label>
                  <input [id]="'p-rotulo-' + i" type="text" pInputText [(ngModel)]="p.rotulo" />

                  <div class="fs-duas">
                    <div>
                      <label [for]="'p-padrao-' + i">Padrão</label>
                      <p-dropdown *ngIf="p.tipo === 'periodo'" [inputId]="'p-padrao-' + i" [options]="padroesPeriodo" [(ngModel)]="p.padrao" [showClear]="true"
                        appendTo="body" styleClass="fs-cheio"></p-dropdown>
                      <p-dropdown *ngIf="p.tipo !== 'periodo' && p.opcoes?.length" [inputId]="'p-padrao-' + i" [options]="p.opcoes" [(ngModel)]="p.padrao"
                        [showClear]="true" appendTo="body" styleClass="fs-cheio"></p-dropdown>
                      <input *ngIf="p.tipo !== 'periodo' && !p.opcoes?.length" [id]="'p-padrao-' + i" type="text" pInputText [(ngModel)]="p.padrao" />
                    </div>
                    <div class="fs-check fs-check-baixo">
                      <p-checkbox [inputId]="'p-obrig-' + i" [(ngModel)]="p.obrigatorio" [binary]="true"></p-checkbox>
                      <label [for]="'p-obrig-' + i">Obrigatório</label>
                    </div>
                  </div>

                  <ng-container *ngIf="p.tipo === 'texto' || p.tipo === 'inteiro'">
                    <label [for]="'p-opcoes-' + i">Opções</label>
                    <input [id]="'p-opcoes-' + i" type="text" pInputText [value]="(p.opcoes || []).join(', ')" (change)="definirOpcoes(p, $any($event.target).value)"
                      placeholder="Separadas por vírgula. Vazio = campo livre." />
                    <label [for]="'p-lookup-' + i">Pesquisa do ERP</label>
                    <input [id]="'p-lookup-' + i" type="text" pInputText [(ngModel)]="p.lookup" placeholder="Vazio = sem pesquisa" />
                  </ng-container>

                  <div class="fs-teste">
                    <span class="fs-teste-titulo">Valor de teste</span>
                    <div class="fs-periodo" *ngIf="p.tipo === 'periodo'">
                      <input type="date" pInputText [(ngModel)]="valoresPrevia[p.nome + '__inicio']" [attr.aria-label]="'Início do teste de ' + p.nome" />
                      <span>a</span>
                      <input type="date" pInputText [(ngModel)]="valoresPrevia[p.nome + '__fim']" [attr.aria-label]="'Fim do teste de ' + p.nome" />
                    </div>
                    <p-dropdown *ngIf="p.tipo !== 'periodo' && p.opcoes?.length" [options]="p.opcoes" [(ngModel)]="valoresPrevia[p.nome]" [showClear]="true"
                      appendTo="body" styleClass="fs-cheio"></p-dropdown>
                    <p-checkbox *ngIf="p.tipo === 'booleano'" [(ngModel)]="valoresPrevia[p.nome]" [binary]="true" label="Marcado"></p-checkbox>
                    <input *ngIf="p.tipo !== 'periodo' && p.tipo !== 'booleano' && !p.opcoes?.length" [type]="p.tipo === 'data' ? 'date' : 'text'" pInputText
                      [(ngModel)]="valoresPrevia[p.nome]" [placeholder]="p.tipo.startsWith('lista') ? 'valores separados por vírgula' : ''"
                      [attr.aria-label]="'Valor de teste de ' + p.nome" />
                  </div>
                </ng-container>
                <small class="fs-ajuda" *ngIf="p.tipo === 'empresas'">O motor preenche com as empresas do usuário. Aqui na Central, com as da base escolhida.</small>
                <div class="fs-perigo">
                  <button pButton type="button" class="p-button-text p-button-danger p-button-sm" icon="pi pi-trash" label="Remover parâmetro"
                    (click)="removerParametro(i)"></button>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
          <button pButton type="button" class="p-button-outlined p-button-sm fs-adicionar" icon="pi pi-plus" label="Adicionar parâmetro"
            (click)="adicionarParametro()"></button>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>Variáveis</span>
            <span class="fs-contador">{{ fonte.variaveis.length }}</span>
          </ng-template>
          <p class="fs-ajuda fs-ajuda-topo">
            Cálculo com nome próprio sobre uma coluna (soma, contagem, distintos…). Não mexe na coluna: no modelo você escolhe se ela aparece ao lado do
            nome do grupo, no total geral ou num indicador. As do JRXML entram aqui sozinhas na importação.
          </p>
          <p-accordion [multiple]="true" styleClass="fs-parametros" *ngIf="fonte.variaveis.length">
            <p-accordionTab *ngFor="let v of fonte.variaveis; let i = index" [selected]="variaveisAbertas.has(v)">
              <ng-template pTemplate="header">
                <div class="fs-param-cabecalho">
                  <code class="fs-param-nome">{{ v.rotulo || v.nome || '?' }}</code>
                  <span class="fs-tipo">{{ nomeTotal(v.total) || v.calculo || 'sem cálculo' }}</span>
                  <span class="fs-param-valor">{{ resumoVariavel(v) }}</span>
                </div>
              </ng-template>
              <div class="fs-form fs-form-param">
                <div class="fs-duas">
                  <div>
                    <label [for]="'v-nome-' + i">Nome</label>
                    <input [id]="'v-nome-' + i" type="text" pInputText class="fs-mono" [(ngModel)]="v.nome" placeholder="totalQtde" />
                  </div>
                  <div>
                    <label [for]="'v-rotulo-' + i">Rótulo que o usuário vê</label>
                    <input [id]="'v-rotulo-' + i" type="text" pInputText [(ngModel)]="v.rotulo" [placeholder]="v.nome || 'Qtde total'" />
                  </div>
                </div>
                <div class="fs-duas">
                  <div>
                    <label [for]="'v-calculo-' + i">Cálculo</label>
                    <p-dropdown [inputId]="'v-calculo-' + i" [options]="calculosVariavel" [(ngModel)]="v.total" [showClear]="true" placeholder="Sem cálculo"
                      appendTo="body" styleClass="fs-cheio" (onChange)="v.resultado = null"></p-dropdown>
                  </div>
                  <div>
                    <label [for]="'v-coluna-' + i">Coluna</label>
                    <p-dropdown [inputId]="'v-coluna-' + i" [options]="fonte.colunas" optionLabel="nome" optionValue="nome" [(ngModel)]="v.coluna"
                      [filter]="fonte.colunas.length > 8" placeholder="Escolha" appendTo="body" styleClass="fs-cheio" emptyMessage="Detecte as colunas primeiro"
                      (onChange)="v.resultado = null"></p-dropdown>
                  </div>
                </div>
                <ng-container *ngIf="v.expressao">
                  <span class="fs-teste-titulo">No Jasper{{ v.escopo ? ' · ' + v.escopo : '' }}</span>
                  <code class="fs-var-expressao">{{ v.expressao }}</code>
                </ng-container>
                <div class="fs-var-resultado" [class.fs-var-alerta]="!v.convertida" *ngIf="v.resultado && !v.total">
                  <i class="pi" [ngClass]="v.convertida ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
                  <span>{{ v.resultado }}</span>
                </div>
                <div class="fs-perigo">
                  <button pButton type="button" class="p-button-text p-button-danger p-button-sm" icon="pi pi-trash" label="Remover variável"
                    (click)="removerVariavel(i)"></button>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
          <button pButton type="button" class="p-button-outlined p-button-sm fs-adicionar" icon="pi pi-plus" label="Adicionar variável"
            (click)="adicionarVariavel()"></button>
        </p-tabPanel>

        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>Colunas</span>
            <span class="fs-contador">{{ fonte.colunas.length }}</span>
          </ng-template>
          <p class="fs-ajuda fs-ajuda-topo">O nome é o alias do SQL, em minúsculas. O rótulo e o tipo são o que o modelo usa por padrão.</p>
          <div class="fs-vazio-grande" *ngIf="!fonte.colunas.length">
            <i class="pi pi-table"></i>
            <p>Use <strong>Detectar colunas</strong> para ler as colunas do SQL na base escolhida.</p>
          </div>
          <div class="fs-colunas" *ngIf="fonte.colunas.length">
            <div class="fs-coluna" *ngFor="let c of fonte.colunas; let i = index" [class.aberta]="colunasAbertas.has(c)">
              <div class="fs-coluna-linha">
                <input type="text" pInputText class="fs-mono fs-coluna-nome" [(ngModel)]="c.nome" [attr.aria-label]="'Nome da coluna ' + (i + 1)" />
                <input type="text" pInputText [(ngModel)]="c.rotulo" placeholder="Rótulo" [attr.aria-label]="'Rótulo da coluna ' + (i + 1)" />
                <p-dropdown [options]="tiposColuna" [(ngModel)]="c.tipo" appendTo="body" styleClass="fs-coluna-tipo"></p-dropdown>
                <button pButton type="button" class="p-button-text p-button-rounded p-button-secondary p-button-sm"
                  [icon]="colunasAbertas.has(c) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" [attr.aria-label]="'Mais opções da coluna ' + (c.nome || i + 1)"
                  (click)="alternarColuna(c)"></button>
              </div>
              <div class="fs-coluna-extra" *ngIf="colunasAbertas.has(c)">
                <label [for]="'c-desc-' + i">Descrição</label>
                <input [id]="'c-desc-' + i" type="text" pInputText [(ngModel)]="c.descricao" placeholder="Aparece para quem monta o modelo" />
                <div class="fs-duas">
                  <div>
                    <label [for]="'c-lookup-' + i">Pesquisa do ERP</label>
                    <input [id]="'c-lookup-' + i" type="text" pInputText [(ngModel)]="c.lookup" placeholder="Vazio = sem pesquisa" />
                  </div>
                  <div class="fs-check fs-check-baixo">
                    <p-checkbox [inputId]="'c-sens-' + i" [(ngModel)]="c.sensivel" [binary]="true"></p-checkbox>
                    <label [for]="'c-sens-' + i">Dado sensível</label>
                  </div>
                </div>
                <div class="fs-perigo">
                  <button pButton type="button" class="p-button-text p-button-danger p-button-sm" icon="pi pi-trash" label="Remover coluna"
                    (click)="removerColuna(i)"></button>
                </div>
              </div>
            </div>
          </div>
          <button pButton type="button" class="p-button-outlined p-button-sm fs-adicionar" icon="pi pi-plus" label="Adicionar coluna"
            (click)="adicionarColuna()"></button>
        </p-tabPanel>
      </p-tabView>
      </div>
    </aside>
  </div>

  <footer class="fs-status" aria-live="polite">
    <span class="fs-status-item" [class.fs-status-desligado]="!service.base?.cnpj">
      <i class="fs-ponto"></i>{{ service.base?.descricao || 'nenhuma base escolhida' }}
    </span>
    <span class="fs-status-item">{{ rotuloSituacao }}</span>
    <span class="fs-status-item" [class.fs-status-erro]="temErro">
      {{ temErro ? 'há problemas nas checagens' : validacao ? 'checagens ok' : 'não validada' }}
    </span>
    <span class="fs-status-item fs-status-fim">{{ ultimaExecucao }}</span>
  </footer>
</div>

<p-dialog [header]="'Salvar versão ' + proximaVersao" [(visible)]="mostrarSalvarVersao" [modal]="true" [style]="{ width: '520px' }">
  <div class="fs-form">
    <p class="fs-ajuda">A versão é imutável. Ela passa por todas as checagens e guarda o plano de execução da base escolhida.</p>
    <label for="notas-versao">O que mudou</label>
    <textarea id="notas-versao" pInputTextarea rows="3" [(ngModel)]="notasVersao"></textarea>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="mostrarSalvarVersao = false"></button>
    <button pButton type="button" label="Salvar versão" icon="pi pi-check" (click)="salvarVersao()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Histórico e diferenças" [(visible)]="mostrarHistorico" [modal]="true" [style]="{ width: '90vw' }" [maximizable]="true">
  <div class="fs-historico">
    <div class="fs-versoes">
      <button type="button" *ngFor="let v of versoes" class="fs-versao" [class.ativa]="versaoComparada?.versao === v.versao" (click)="comparar(v)">
        <strong>v{{ v.versao }}</strong>
        <span>{{ v.salvoPor }} · {{ v.salvoEm | date: 'dd/MM/yyyy HH:mm' }}</span>
        <small *ngIf="v.notas">{{ v.notas }}</small>
      </button>
    </div>
    <div class="fs-diff" *ngIf="versaoComparada">
      <div class="fs-diff-titulo">
        <span>v{{ versaoComparada.versao }} (esquerda) × editor atual (direita)</span>
        <button pButton type="button" class="p-button-outlined p-button-sm" label="Carregar esta versão no editor" (click)="restaurar(versaoComparada)"></button>
      </div>
      <habil-editor-diff *ngIf="mostrarHistorico" [original]="versaoComparada.fonte?.sql" [modificado]="fonte.sql" altura="60vh"></habil-editor-diff>
    </div>
  </div>
</p-dialog>
